import { useTranslations } from 'next-intl';
import { Button } from '@trussworks/react-uswds';

export default function Error403() {
  const t = useTranslations('error');
  return (
    <>
      {/* Use window.location instead of router to avoid breaking the error boundary */}
      {/* eslint-disable-next-line @next/next/no-location-assign-relative-destination */}
      <Button type="button" onClick={() => window.location.assign(`${process.env.NEXT_PUBLIC_BASE_PATH}/home`)}>
        {t(`button.home`)}
      </Button>
    </>
  );
}
